import { createContext, useState, useEffect } from 'react'
import { attendantApi } from '../services/api'

export const RouterContext = createContext();

export function RouterProvider({ children }) {
    const [router, setRouter] = useState('make-a-call')
    const [routerParams, setRouterParams] = useState()
    const [alertMessage, setAlertMessage] = useState({
        status: '',
        message: '',
    })
    const [me, setMe] = useState()

    useEffect(() => {
        attendantApi.get('attendants/me').then(res => {
            setMe(res.data)
        })
    }, [])

    return (
        <RouterContext.Provider value={{
            router,
            setRouter,
            routerParams,
            setRouterParams,
            me,
            alertMessage,
            setAlertMessage
        }}>
            {children}
        </RouterContext.Provider>
    )
}
